/* eslint-disable no-console */
import ConexionTA from '@/js/services/traceability/APITraceability';
/* cambiar importacion */
//* ************************************** */
//* ********* MOVIMIENTOS DE ALMACEN  ********* */
//* ************************************** */

let movimientosDeAlmacen = [];

/** *** Método obtenerMovimientosDeAlmacenPendientes */
function obtenerMovimientosDeAlmacenPendientes() {
  console.log('soporteSincronizacion->obtenerMovimientosDeAlmacenPendientes');
  if (localStorage.getItem('movimientosDeAlmacen') != null) {
    movimientosDeAlmacen = JSON.parse(localStorage.getItem('movimientosDeAlmacen'));
  }
  return movimientosDeAlmacen;
}

/** *** Método guardarMovimientosDeAlmacenPendientes */
function guardarMovimientosDeAlmacenPendientes(movimientosDeAlmacenPendientes) {
  console.log('soporteSincronizacion->guardarMovimientosDeAlmacenPendientes');
  console.log(movimientosDeAlmacenPendientes);
  movimientosDeAlmacen = movimientosDeAlmacenPendientes;
  localStorage.setItem('movimientosDeAlmacen', JSON.stringify(movimientosDeAlmacen));
}

/** ObtenerUltimasmovimientosPendientesLineaDeProduccion */
// Este método añade los mensajes de error en los movimientos de almacen que no se
// han podido completar y elimina los movimientos realizados del local storage.
function ProcesarResultadosCambiosDeUbicacion(resultadoCambiosUbicacion) {
  console.log('PCMovimientosDeAlmacenPendientesDeSincronizar->ProcesarResultadosCambiosDeUbicacion');
  // Eliminamos los movimientos pendientes efectuados correctamente del LocalStorage
  const tempMovimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los pendientes del soporteSincronizacion
  resultadoCambiosUbicacion.forEach((movimientoRealizado) => {
    for (let i = tempMovimientosPendientes.length - 1; i >= 0; i -= 1) {
      if (movimientoRealizado.UnidadLogistica.NumeroSerie === tempMovimientosPendientes[i].ElementoMover.NumeroSerie || movimientoRealizado.UnidadLogistica.CodigoBarrasPale === tempMovimientosPendientes[i].ElementoMover.CodigoBarrasPale) {
        // Si el Movimiento  fue correcto.
        if (movimientoRealizado.Resultado) {
          tempMovimientosPendientes.splice(i, 1); break;
        } else {
          // Movimiento no correcto añadimos el mensaje
          const UltimoIntentoSincronizacion = { MensajeError: movimientoRealizado.Mensaje, FechaEstado: new Date() };
          tempMovimientosPendientes[i].UltimoIntentoSincronizacion = UltimoIntentoSincronizacion;
        }
      }
    }
  });

  // Actualizamos
  guardarMovimientosDeAlmacenPendientes(tempMovimientosPendientes);
}

/** *** Método SincronizacionDeCambiosDeUbicacionPendientes */
function SincronizacionDeCambiosDeUbicacionPendientes() {
  console.log('soporteSincronizacion->SincronizacionDeCambiosDeUbicacionPendientes');

  if (navigator.onLine) {
    const temMovimientosPendientes = obtenerMovimientosDeAlmacenPendientes(); // Obtenemos los pendientes del soporteSincronizacion
    ConexionTA.callSincronizarMovimientosCambioUbicacion(JSON.stringify(temMovimientosPendientes)).then((result) => {
      if (result.Valor) {
        guardarMovimientosDeAlmacenPendientes([]); // Todos se han realizado correctos los borramos
      } else {
        const resultadoCambiosUbicacion = JSON.parse(result.Mensaje);
        ProcesarResultadosCambiosDeUbicacion(resultadoCambiosUbicacion);
      }
    });
  } else {
    // No disponemos de conexion.
    setTimeout(SincronizacionDeCambiosDeUbicacionPendientes, 60000); // Volvemos a programar el reintento.
  }
}
/** *** Método ProgramarSincronizacionDeCambiosDeUbicacionPendientes */
function ProgramarSincronizacionDeCambiosDeUbicacionPendientes() {
  console.log('soporteSincronizacion->ProgramarSincronizacionDeCambiosDeUbicacionPendientes');
  setTimeout(SincronizacionDeCambiosDeUbicacionPendientes, 60000);
}

export {
  guardarMovimientosDeAlmacenPendientes,
  obtenerMovimientosDeAlmacenPendientes,
  ProcesarResultadosCambiosDeUbicacion,
  ProgramarSincronizacionDeCambiosDeUbicacionPendientes,
};
